// ================================
// INSTALL PROMPT HOOK
// ================================
import { useState, useEffect } from 'react';
import { canPromptInstall, subscribe, isStandalone, isIOS, promptInstall } from './installPrompt';

export default function useInstallPrompt() {
  const [canInstall, setCanInstall] = useState(canPromptInstall());

  useEffect(() => subscribe(() => setCanInstall(canPromptInstall())), []);

  return {
    canInstall,          // Android/Chrome/Edge: a real install trigger is ready
    standalone: isStandalone(), // already installed/launched from the home screen
    ios: isIOS(),         // iOS Safari: no programmatic trigger, show instructions instead
    promptInstall
  };
}
